import {useSelector} from 'react-redux';

export function useEventNewsArticle(eventId, articleId) {
    return useSelector(state => state.events[eventId]?.news?.indexed?.[articleId]);
}
